import {FETCH_VACANCIES_REQUEST, FETCH_VACANCIES_SUCCES, FETCH_VACANCIES_ERROR} from '../constants/Vacancies'

const initialState = {
  count: 0,
  next: null,
  list: [],
  hasErrored: false,
  isLoading: false,
  showCity: false
};

export default function vacancies(state = initialState, action) {
  switch (action.type) {
    case FETCH_VACANCIES_REQUEST:
      // return {...state, isLoading: action.concated ? true : false};
      return {...state, isLoading: true};
    case FETCH_VACANCIES_SUCCES:
      return {
        ...state,
        count: action.payload.count,
        next: action.payload.next,
        list: action.concated ? state.list.concat(action.payload.results) : action.payload.results,
        showCity: action.showCity,
        isLoading: false
      };
    case FETCH_VACANCIES_ERROR:
      return {...state, hasErrored: true, isLoading: false};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/vacancies.js